import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "chevron-up",
  "use": "chevron-up-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"chevron-up\"><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" d=\"M19 15.5l-7-7-7 7\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol